<template>
  <button class="button disclosure-button">
    <div class="grow">
      <slot />
    </div>
    <div class="disclosure rounded-full text-white px-4 py-0.5">
      <slot name="disclosure">
        <span v-if="value">
          {{ formatCents(value) }}
        </span>
        <span v-else-if="bundle.validSize">
          ${{ $cart.totalPrice / 100 }}
        </span>
        <span v-else>
          {{ bundle.totalQuantity }}/{{ bundle.size }}
        </span>
      </slot>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useBundleStore } from '@/stores'
const bundle = useBundleStore()
import { formatCents } from '@/utils'
export interface Props {
  value?: number
}
defineProps<Props>()
</script>

<style>
@reference 'tailwindcss';

.disclosure-button {
  &:disabled .disclosure,
  &.\+gray .disclosure {
    @apply !bg-neutral-500;
  }
  &.\+green .disclosure,
  &.\+border .disclosure {
    @apply bg-green-600;
  }
}
</style>
